export const symbols_arrows = [
  { char: '➔', name: 'Right Arrow', nameZh: '指向右', keywords: ['next', 'go', 'arrow'], hot: true },
  { char: '➤', name: 'Bullet Arrow', nameZh: '箭頭重點', keywords: ['point', 'focus', 'bullet'], hot: true },
  { char: '➥', name: 'Return Arrow', nameZh: '轉向箭頭', keywords: ['back', 'turn', 'return'] },
  { char: '➡️', name: 'Right Arrow Emoji', nameZh: '藍色向右', keywords: ['go', 'direction', 'blue'] },
  { char: '⬅️', name: 'Left Arrow Emoji', nameZh: '藍色向左', keywords: ['back', 'direction'] },
  { char: '⬆️', name: 'Up Arrow Emoji', nameZh: '藍色向上', keywords: ['up', 'growth', 'top'] },
  { char: '⬇️', name: 'Down Arrow Emoji', nameZh: '藍色向下', keywords: ['down', 'below'] },
  { char: '↗️', name: 'Up-Right Arrow', nameZh: '右上成長', keywords: ['growth', 'profit', 'up'] },
  { char: '↘️', name: 'Down-Right Arrow', nameZh: '右下趨勢', keywords: ['loss', 'down'] },
  { char: '↔️', name: 'Left-Right Arrow', nameZh: '左右切換', keywords: ['switch', 'compare'] },
  { char: '↕️', name: 'Up-Down Arrow', nameZh: '上下滑動', keywords: ['scroll', 'move'] },
  { char: '🔄', name: 'Refresh', nameZh: '循環更新', keywords: ['update', 'loop', 'sync'], hot: true },
  { char: '🔁', name: 'Repeat', nameZh: '重複播放', keywords: ['loop', 'again'] },
  { char: '⤴️', name: 'Curve Up', nameZh: '曲線向上', keywords: ['improve', 'up'] },
  { char: '⤵️', name: 'Curve Down', nameZh: '曲線向下', keywords: ['back', 'down'] },
];